import * as sharedTypes from 'src/actions/shared/sharedTypes';

import skillsResource from './skillsResource';
import skillHierarchyResource from './skillHierarchyResource';
import { sortMergedSkills } from './skillsUtils';

const fetchSkillsAndHierarchies: sharedTypes.AppThunk = () => async (dispatch, getState) => {
  dispatch(skillsResource.actions.dataMergeStarted({}));

  await Promise.all([dispatch(skillsResource.effects.fetchAll()), dispatch(skillHierarchyResource.effects.fetchAll())]);

  const state = getState();

  if (state.skills.loadingState === 'succeeded' && state.skillHierarchy.loadingState === 'succeeded') {
    const skills = sortMergedSkills(state);
    dispatch(skillsResource.actions.dataMergeFinished(skills));
  }
};

export default fetchSkillsAndHierarchies;
